import React from "react";

import { Props } from "./types";
import { TasksProgression } from "./tasksProgression";
import { Stats } from "./stats";
import { Milestones } from "./milestones";
import styles from "./styles.scss";

function MonitoringLoader(props: Props) {
  return (
    <div className={styles.monitoring}>
      <div className={styles.progressions}>
        <div className={styles.tasksProgression}>
          <TasksProgression />
        </div>
        <div className={styles.tasksProgression}>
          <TasksProgression />
        </div>
        <div className={styles.tasksProgression}>
          <TasksProgression />
        </div>
      </div>
      <div>
        <Stats />
      </div>
      <div className={styles.milestones}>
        <Milestones />
      </div>
    </div>
  );
}

export { MonitoringLoader };
